export function getTeamCode(team: any, fallback?: string) {
  const code = team?.code || team?.team_code || team?.abbr || team?.short_code;
  if (code != null && String(code).trim()) return String(code).trim();
  return fallback;
}

